import React from "react";
import "./Quytrinh.css";

const steps = [
  {
    id: 1,
    short: "Bắt đầu",
    title: "Liên hệ & nhận báo phí",
    time: "Chỉ 2 phút",
    tone: "orange",
    desc: "Gọi điện hoặc nhắn tin cho chúng tôi. Báo số tiền cần rút và loại thẻ. Phí 1% cố định.",
  },
  {
    id: 2,
    short: "Thực hiện",
    title: "Nhân viên đến — quẹt thẻ tại chỗ",
    time: "30 phút có mặt",
    tone: "green",
    desc: "Nhân viên mang máy đến tận nơi bạn yêu cầu — nhà riêng, văn phòng hoặc quán cà phê.",
  },
  {
    id: 3,
    short: "Hoàn tất",
    title: "Hoàn tất giao dịch",
    time: "Dưới 5 phút",
    tone: "purple",
    desc: "Thanh toán phí dịch vụ và nhận tiền",
  },
];

export default function Quytrinh() {
  return (
    <section className="process">
      <div className="process__container">
        <div className="process__top">
          <div className="process__badge">
            <span className="process__badge-dot" />
            Áp dụng cho 5.000+ khách
          </div>

          <h2 className="process__title">Quy trình 3 bước chuẩn</h2>
          <p className="process__subtitle">
            Rút nhanh chóng, tổng thời gian chưa đến 30 phút
          </p>
        </div>

        <div className="process__layout">
          <div className="process__timeline">
            <div className="timeline-line" />

            {steps.map((step, index) => (
              <div
                key={step.id}
                className={`timeline-item ${
                  index === 0 ? "timeline-item--active" : ""
                }`}
              >
                <div className="timeline-item__circle">
                  <span className="timeline-item__number">{step.id}</span>
                  <span className="timeline-item__label">{step.short}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="process__cards">
            {steps.map((step) => (
              <article
                key={step.id}
                className={`process-card process-card--${step.tone} ${
                  step.id === 1 ? "process-card--active" : ""
                }`}
              >
                <div className="process-card__head">
                  <h3>{step.title}</h3>
                  <span
                    className={`process-card__time process-card__time--${step.tone}`}
                  >
                    {step.time}
                  </span>
                </div>

                <p className="process-card__desc">{step.desc}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="process-cta">
          <div className="process-cta__actions">
            <a
              onClick={() => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                  event: "goi",
                });
              }}
              href="tel:0941395019"
              className="cta-btn cta-btn--call"
            >
              📞 Gọi ngay 0941 395 019
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
